export default "__VITE_ASSET__B2kPwdIE__"